import { useMemo } from 'react';
import { Location, useLocation } from 'react-router';

import { RouteNameEnum } from '../../../enums';
import { useAuth } from '../../../hooks';
import { UseAuth } from '../../../interfaces';
import { getRouteNameByUrl } from '../../../utils';

export const useAnonymousMode: () => boolean = (): boolean => {
  const { appSettings, userData }: UseAuth = useAuth();
  const { pathname }: Location = useLocation();
  const currentRouteName: RouteNameEnum | undefined = useMemo((): RouteNameEnum | undefined => getRouteNameByUrl(pathname), [pathname]);
  const routesAvailableWhenAppInAnonymousMode: RouteNameEnum[] = useMemo(
    (): RouteNameEnum[] => [RouteNameEnum.ContactDataConfirm],
    []
  );

  const isAppInterfaceHidden: boolean = useMemo(
    (): boolean => (
      (
        !!appSettings?.passwordExpirationInfo?.forceChange
        || !!userData?.requiredActions?.length
      )
      && (!!currentRouteName && !routesAvailableWhenAppInAnonymousMode.includes(currentRouteName))
    ),
    [
      userData?.requiredActions?.length,
      appSettings?.passwordExpirationInfo?.forceChange,
      currentRouteName,
      routesAvailableWhenAppInAnonymousMode,
    ]
  );

  return isAppInterfaceHidden;
};
